import { commonShortFieldLabels, commonShortNouns } from "./common-short-fields";

export const sharedCoreZh = {
  columns: {
    id: "ID",
    name: commonShortFieldLabels.name,
    code: commonShortFieldLabels.code,
    actions: "操作",
    requestId: "编排 ID",
    status: commonShortNouns.status,
    latestTask: "最新任务",
    relatedTaskCount: "关联任务数",
    createdBy: commonShortFieldLabels.createdBy,
    createdAt: commonShortFieldLabels.createdAt,
    updatedBy: commonShortFieldLabels.updatedBy,
    updatedAt: commonShortFieldLabels.updatedAt,
    operator: "操作者",
    vmId: "虚机 ID",
    accessEndpoint: "访问入口",
    destroyedAt: "销毁时间",
    failureCode: "失败码",
  },
  values: {
    expired: "已过期",
    accessMethodWeb: "Web",
    accessMethodSsh: "SSH",
    accessMethodRdp: "RDP",
    accessMethodVnc: "VNC",
    accessMethodPortMapping: "端口映射",
    noAccessEndpoints: "暂无访问端点",
    workspaceAccessOnly: "仅运行节点可访问",
    undefinedSource: "未定义来源",
    runtimePublicHost: "运行时公网主机",
    runtimePublicHostHelp: "控制面反向访问 node-runtime 时使用的主机名或地址；runtime_base_url 将由该值和 runtime_addr 推导。",
    providerTypeLocal: "本地",
    providerTypeCenter: "资产中心",
    executionProviderTypeLocal: "本地执行",
    executionProviderTypeCenter: "执行底座",
    providerTypeLocalRuntime: "本地运行时",
    providerKeyLocalRuntimeDocker: "本地运行时 Docker",
    providerKeyLocalRuntimeKvm: "本地虚机运行",
    providerKeyAliyunAckContainer: "阿里云 ACK 容器",
    providerKeyAliyunEcsKvm: "阿里云 ECS KVM",
    providerKeyUnknown: "未定义提供方",
    providerPhaseTargetBusiness: "目标态",
    providerPhaseTargetIdentity: "已接入统一身份",
    providerPhaseTargetAsset: "已接入资产中心",
    providerPhaseTargetExecution: "已接入执行底座",
    providerPhaseTransition: "迁移过渡中",
    providerPhaseLegacy: "遗留模式",
    providerPhaseDisabled: "未启用",
  },
  legend: {
    retryableFailed: "可重试失败",
  },
  forms: {
    imagePlaceholder: "镜像名称，例如 ghcr.io/example/app:1.0.0",
    imageRequired: "请输入镜像名称",
  },
  messages: {
    invalidPort: "端口必须是 1-65535 的整数",
  },
  parameterFields: {
    item: "参数字段 #{index}",
    name: "字段名",
    label: "显示标签",
    type: "字段类型",
    options: "可选项",
    optionsHint: "例如：a,b,c",
    required: "必填",
    sensitive: "敏感",
    description: "字段说明",
  },
  fields: {
    description: "说明",
  },
  applicationContract: {
    requiredParameterFieldName: "请输入参数字段名",
    addParameterField: "添加参数字段",
    actionItem: "动作 #{index}",
    actionName: "动作名",
    requiredActionName: "请输入动作名",
    actionLabel: "动作标签",
    actionEntrypoint: "动作入口",
    actionOutputKey: "输出键",
    actionDescription: "动作说明",
    addActionInputField: "添加动作输入字段",
    addActionItem: "添加动作",
    outputItem: "输出 #{index}",
    outputKey: "输出键",
    outputLabel: "输出标签",
    outputType: "输出类型",
    outputFromAction: "来源动作",
    outputDescription: "输出说明",
    addOutputItem: "添加输出",
  },
} as const;
